import type { QuasarPluginOptions } from 'quasar'
import type { UserModule } from '~/types'
import { Dark, LocalStorage, Notify, Quasar } from 'quasar'
import iconSet from 'quasar/icon-set/svg-eva-icons.js'

export const install: UserModule = (ctx) => {
  ctx.app.use(Quasar, {
    config: {
      ripple: false,
      // dark: isDark.value,
    },
    plugins: {
      Dark,
      Notify,
      LocalStorage,
    },
    iconSet,
  } as QuasarPluginOptions,
  {
    req: {
      url: ctx.router.currentRoute.value.path,
      headers: {},
    },
  })
}
